export const environment = {
  production: false,
  api_url: 'https://gesztenyeliget-c4445-default-rtdb.europe-west1.firebasedatabase.app/',
  auth_url: 'https://www.googleapis.com/identitytoolkit/v3/relyingparty/verifyPassword?key=AIzaSyC8FX1leqTj8EsV-v8WR248Y73VBoPxUlU',
  firebase: {
    apiKey: 'AIzaSyC8FX1leqTj8EsV-v8WR248Y73VBoPxUlU',
    databaseURL: 'https://gesztenyeliget-c4445-default-rtdb.europe-west1.firebasedatabase.app/',
    projectId: 'gesztenyeliget-c4445',
    storageBucket: 'gs://gesztenyeliget-c4445.appspot.com/',
  }
};
